import { loadStripe } from '@stripe/stripe-js';
import api from '../config/api';

// The backend decides test vs live mode, so use the publishable key it serves; the
// build-time key is only a fallback. Mixing modes makes every card payment fail.
let stripePromise = null;

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = api
      .get('/app-config')
      .then((res) => res.data?.stripePublishableKey)
      .catch(() => null)
      .then((key) => {
        const publishableKey = key || process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
        return publishableKey ? loadStripe(publishableKey) : null;
      })
      .then((stripe) => {
        // Don't cache a failed/empty result: a transient /app-config error must not
        // disable Stripe permanently. Clear the memo so the next call retries.
        if (!stripe) stripePromise = null;
        return stripe;
      })
      .catch((err) => {
        stripePromise = null;
        throw err;
      });
  }
  return stripePromise;
};

// Resolves the publishable key the backend is actually configured with (test or live),
// so UI gating uses the same source of truth as getStripe() rather than a build-time env var.
export const isStripeAvailable = async () => {
  try {
    const res = await api.get('/app-config');
    const key = res.data?.stripePublishableKey || process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    return Boolean(key);
  } catch {
    return Boolean(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  }
};
